import { render, staticRenderFns } from "./Wrong.vue?vue&type=template&id=6d23e16c&scoped=true"
import script from "./Wrong.vue?vue&type=script&lang=js"
export * from "./Wrong.vue?vue&type=script&lang=js"
import style0 from "./Wrong.vue?vue&type=style&index=0&id=6d23e16c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23e16c",
  null
  
)

export default component.exports